import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { RoutePath } from 'constants/app.constant';
import { appSelectors } from 'redux/ducks/app';
import { isSparkVariantEnabled } from 'reports/cw/helpers/spark.helper';
var SparkRouteGuard = function (_a) {
    var children = _a.children;
    var featureFlags = useSelector(appSelectors.getFeatureFlags);
    if (!isSparkVariantEnabled(featureFlags)) {
        return <Redirect to={RoutePath.reportingPortal}/>;
    }
    return <>{children}</>;
};
export default SparkRouteGuard;
